const GET_DOMAIN = window.location.href;
const DEV_ENV = {
    url: {
        REALEX_HPP_URL: 'https://pay.sandbox.elavonpaymentgateway.com/pay',
    },
};

const PROD_ENV = {
    url: {
        REALEX_HPP_URL: 'https://pay.elavonpaymentgateway.com/pay',
    },
};

export const EXTERNAL_ENDPOINT =
    GET_DOMAIN.indexOf('testwww') > 0
        ? DEV_ENV // if test env
        : GET_DOMAIN.indexOf('localhost') > 0
        ? DEV_ENV // change DEV_ENV for development env or PROD_ENV for production
        : PROD_ENV; // if prod env
